import { PageHeaderProps } from '@design-system/page-header-standard';

import TMPLinkWrap from '~/components/TMPLinkWrap';
import { headingBlockMapper } from '~/mappers/headingBlock';
import { imageMapper } from '~/mappers/image';
import { shareBlockMapper } from '~/mappers/shareBlock';

import { PageFields, PageHeader } from './models';

export const breadcrumbsMapper = (items: PageFields['breadcrumbs']) =>
  // TODO: check why items are null - this should not happen in general
  items
    ? items.map(({ fullPath, title }) => ({
        href: fullPath,
        children: title,
      }))
    : [];

export const pageHeaderMapper = ({
  pageHeader,
  fields,
}: {
  pageHeader: PageHeader;
  fields: PageFields;
}) => {
  const {
    componentId,
    headingBlock,
    imageElement,
    inlineImage,
    hiddenHeading,
    showBreadcrumbs,
    showShareBlock,
    mode,
    variant,
    breadcrumbs: [{ hideLastItem, navigationName, overflowButton }],
    shareBlock,
    ctaBlocks,
  } = pageHeader;

  return {
    // TODO - HKX-1311 - replace next line with: id: componentId,
    ...(componentId && { id: componentId }),
    headingBlock: headingBlockMapper({
      ...headingBlock,
      ctaBlocks,
    }),
    ...(imageElement.length > 0 && {
      imageElement: imageMapper(imageElement[0], true, inlineImage),
    }),
    shareBlock: shareBlockMapper({
      ...shareBlock[0],
      align: headingBlock?.ui[0]?.ui?.align,
    }),
    breadcrumbs: {
      navigationName,
      hideLastItem,
      items: breadcrumbsMapper(fields.breadcrumbs),
      overflowBtn: {
        children: overflowButton,
      },
      linkComponent: TMPLinkWrap,
    },
    hiddenPageHeading: hiddenHeading,
    showBreadcrumbs,
    showShareBlock,
    mode,
    variant,
  } as PageHeaderProps;
};
